import React from 'react';
import PropTypes from 'prop-types';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import classNames from 'classnames';
import Checkbox from '../../../Checkbox/Checkbox';

const propTypes = {
  label: PropTypes.string.isRequired,
  published: PropTypes.bool.isRequired,
  publishable: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool,
  onClickPublish: PropTypes.func.isRequired,
  onClickEditItem: PropTypes.func.isRequired,
  onClickRemoveItem: PropTypes.func.isRequired,
  createdOn: PropTypes.string,
  updatedOn: PropTypes.string,
};

const defaultProps = {
  isSelected: false,
  createdOn: '-',
  updatedOn: '-',
};

const DragHandle = SortableHandle(() => <span><i className="icon-arrows_hamburger2" /></span>);

const ListItem = SortableElement(({
  label, published, publishable,
  isSelected, onClickPublish, onClickRemoveItem, onClickEditItem,
  createdOn, updatedOn,
}) => (
  <div
    style={{ zIndex: '10000' }}
    className={classNames('c-bb-table__tr', { 'c-bb-table__tr_selected': isSelected })}
  >
    <div className="c-bb-table__td items-list__drag-icon-td items-list__drag-icon">
      <DragHandle />
    </div>
    <div className="c-bb-table__td items-list__label">
      { label }
    </div>
    <div className="c-bb-table__td c-bb-table__td_center">
      { createdOn }
    </div>
    <div className="c-bb-table__td c-bb-table__td_center">
      { updatedOn }
    </div>
    <div className="c-bb-table__td c-bb-table__td_center items-list__published-td">
      <Checkbox
        onClick={onClickPublish}
        checked={published}
        disabled={!publishable}
        className="items-list__published-btn"
      />
    </div>
    <div className="c-bb-table__td c-bb-table__td--actions">
      <div>
        <button className="bb-panel__button" onClick={onClickEditItem}>
          <i className="icon-edit" />
        </button>
        <button className="bb-panel__button" onClick={onClickRemoveItem}>
          <i className="icon-close" />
        </button>
      </div>
    </div>
  </div>
));

export default ListItem;

ListItem.propTypes = propTypes;
ListItem.defaultProps = defaultProps;




// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleItems/BaseModuleItemsList/ListItem.js